import { Card, CardActions, Grid, Skeleton } from '@mui/material'
import { photoLabCreationGridProps } from './PhotoLabCreation'

export default function PhotoLabCreationSkeleton() {
  return <Grid item {...photoLabCreationGridProps}>
    <Card elevation={0} sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      '& .MuiSkeleton-root': {
        backgroundColor: '#dedede',
      },
    }}>
      <div style={{
        paddingBottom: '90%',
        height: 0,
        position: 'relative'
      }}>
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
          }}
        />
      </div>
      <CardActions sx={{ minHeight: 64, backgroundColor: 'rgba(0, 0, 0, 0.11)' }} />
    </Card>
  </Grid>
}
